import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';

import { ImageVariant } from './Image';

const { image: ImageTokens } = tokens;
/**
 * Generate border radius
 * - Currently by variant and orientation
 */
export const getBorderRadiusByVariant = (variant: ImageVariant, orientation: string) => {
  switch (variant) {
    case 'arch':
      return {
        borderTopLeftRadius: ImageTokens.radius.imageCornerRadius.full,
        borderTopRightRadius: ImageTokens.radius.imageCornerRadius.full,
        borderBottomLeftRadius: ImageTokens.radius.imageCornerRadius['16x'],
        borderBottomRightRadius: ImageTokens.radius.imageCornerRadius['16x'],
      };
    case 'circle':
      return {
        borderTopLeftRadius: ImageTokens.radius.imageCornerRadius.full,
        borderTopRightRadius: ImageTokens.radius.imageCornerRadius.full,
        borderBottomLeftRadius: ImageTokens.radius.imageCornerRadius.full,
        borderBottomRightRadius: ImageTokens.radius.imageCornerRadius.full,
      };
    case 'article':
      return {
        borderTopLeftRadius:
          orientation === 'top' || orientation === 'left'
            ? ImageTokens.radius.imageCornerRadius['8x']
            : ImageTokens.radius.imageCornerRadius['2x'],
        borderTopRightRadius:
          orientation === 'top' || orientation === 'right'
            ? ImageTokens.radius.imageCornerRadius['8x']
            : ImageTokens.radius.imageCornerRadius['2x'],
        borderBottomLeftRadius:
          orientation === 'bottom' || orientation === 'left'
            ? ImageTokens.radius.imageCornerRadius['8x']
            : ImageTokens.radius.imageCornerRadius['2x'],
        borderBottomRightRadius:
          orientation === 'bottom' || orientation === 'right'
            ? ImageTokens.radius.imageCornerRadius['8x']
            : ImageTokens.radius.imageCornerRadius['2x'],
      };
    default:
      break;
  }
};
